import $http from '../../axios';
import {Notification, MessageBox} from 'element-ui';

//Crear tercero
export async function addContact({commit, state}) {

    state.client.email_electronic_invoice = state.client.email;

    await $http
        .post('/api/almacenar-cliente-modal', state.client)
        .then(response => {
            Notification.success({
                title: 'Éxito!',
                message: 'Cliente guardado éxitosamente',
                type: 'success',
                duration: 2000,
                customClass: 'notification-box'
            });
            commit('SetId', response.data.data);
            commit('setComplete', true);
        })
        .catch(error => {
            let message;
            if (error.response.status == 422) {
                message = 'Algunos campos no se registraron correctamente';
            } else {
                message = error.message;
            }
            MessageBox.alert(message, 'Error', {
                confirmButtonText: 'Aceptar',
                type: 'error'
            });
        });
}

//Función para mapear los parametros y retornarlos en un mismo formato para todos los select
function mapParameters(parameters) {
    return parameters.map(p => {
        return {
            value: p.id,
            code: p.code_parameter,
            label: p.name_parameter
        };
    });
}

// Obtiene los tipos de documento
export async function fetchDocumentTypes({dispatch, state, rootState, commit}) {

    if (!!state.identificationTypes.length) {
        return;
    }

    await $http.get(`/api/parametros-por-codigo/052`)
        .then((response) => {
            commit('setIdentificationTypes', response.data.data);
        })
        .catch((error) => {

        });
}

export async function fetchContacts({commit, state, rootState, dispatch}) {
    state.params_contacts.type = 'is_customer';
    let params = state.params_contacts;

    await $http.get('/api/terceros-lite', {params})
        .then(async response => {

            let contact;
            let contacts = response.data.data;

            if (state.params_contacts.with_contact_warehouses) {
                contact = contacts.find(c => c.identification === state.params_contacts.filter && c.warehouses && c.warehouses.length === 1);
            } else {
                contact = contacts.find(c => c.identification === state.params_contacts.filter);
            }

            if (contact) {
                if (state.params_contacts.from_identification) {
                    await dispatch('fetchContactById', contact.id);
                }else{
                    await dispatch('fetchContactById', contact.id);
                    commit('setContacts', [contact]);
                }
            } else if (!state.params_contacts.from_identification) {
                commit('setContacts', contacts);
                let client = JSON.parse(JSON.stringify(state.client));

                client.identification = '';
                client.price_list_id = rootState.pointOfSale.model.price_list_id;

                commit('setClient', client);
            }
        })
        .catch(error => {
            console.error(error);
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 1500,
                customClass: 'notification-box'
            });
        });
}

export async function fetchContactById({commit, state, rootState}, id) {
    await $http.get('/api/terceros/' + id)
        .then(async response => {

            const client = response.data.data;

            commit('setClient', client);
            // commit('setContacts', [
            //     ...state.contacts,
            //     client
            // ]);

            if (client.city) {
                commit('setCities', [client.city]);

                if (client.city.department) {
                    commit('setDepartments', [client.city.department]);
                }
            }
        })
        .catch(error => {
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 1500,
                customClass: 'notification-box'
            });
        });
}

export async function fetchContactByIdAndContactWarehouseId({commit, state, rootState}, {
    contact_id,
    contact_warehouse_id
}) {
    let params = {
        contact_warehouse_id
    };

    await $http.get('/api/terceros/' + contact_id, {params})
        .then(async response => {

            const client = response.data.data;

            commit('setClient', client);

            if (client.warehouses.length && client.warehouses[0]) {
                commit('setCities', [client.warehouses[0].city]);

                if (client.warehouses[0].city.department) {
                    commit('setDepartments', [client.warehouses[0].city.department]);
                }
            } else if(client.city) {
                commit('setCities', [client.city]);

                if (client.city.department) {
                    commit('setDepartments', [client.city.department]);
                }
            }

            if (contact_warehouse_id && client.warehouses.length) {
                commit('setContactWarehouse', client.warehouses[0]);
                commit('setAddressToClient', client.warehouses[0].address);
            }
        })
        .catch(error => {
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 1500,
                customClass: 'notification-box'
            });
        });
}

// Obtiene las listas de preeciops
export async function fetchPriceLists({dispatch, state, rootState, commit}) {
    if (!state.priceLists.length) {
        await dispatch('parameters/listParameter', {params: {idParamTable: 14, paginate: false}}, {root: true});
        commit('setPriceLists', mapParameters(rootState.parameters.parameters));
    }
}

// Obtiene las responsabilidades fiscales
export async function fetchTaxResponsibilities({dispatch, state, rootState, commit}) {
    if (!state.tax_responsibilities.length) {
        await dispatch('parameters/listParameter', {params: {idParamTable: 96, paginate: false}}, {root: true});
        commit('setTaxResponsibilities', rootState.parameters.parameters);
    }
}

export async function fetchModel({commit, state}, model_id) {
    if (state.selected_model && model_id === state.selected_model.id) {
        return;
    }

    await $http
        .get('/api/obtener-modelo/' + model_id)
        .then(response => {
            commit('setSelectedModel', response.data.data);
        }).catch(error => {
            Notification.error({
                title: '¡Error!',
                message: error.message,
                type: 'error',
                duration: 1500,
                customClass: 'notification-box'
            });
        });

}

export async function fetchCities({commit, state}) {
    state.client.city_id = null;

    let params = {
        department_id: state.client.city.department_id
    };

    await $http.get('/api/ciudades', {params})
        .then((response) => {
            commit('setCities', response.data.data);
        })
        .catch((error) => {
            console.error(error);
        });
}

export async function fetchDepartments({commit, state}) {
    await $http.get('/api/departamentos').then(response => {
        commit('setDepartments', response.data.data);
    });
}

export async function getSellers({state, commit}) {

    if (!!state.sellers.length) {
        return;
    }

    await $http.get('/api/lista-vendedores')
        .then(response => {
            commit('setSellers', response.data.data);
        }).catch(error => {
                Notification.error({
                    title: 'Error!',
                    message: error.message,
                    type: 'error',
                    duration: 3000,
                    customClass: 'notification-box'
                });
            }
        );
}

/**
 * Obtener suscriptor.
 */
export async function getSubscriber({commit, dispatch, state}) {
    await $http
        .get(`/api/suscriptor`)
        .then(response => {
            commit('setSubscriber', response.data.data);
        })
        .catch(error => {
            console.error(error);
        });
}

/**
 * Request tipo GET para obtener taxes.
 * @author Jhon García
 */
export async function getTaxes({commit, state}) {

    await $http
        .get(`/api/impuestos`)
        .then(response => {
            commit('setTaxes', response.data.data);
        })
        .catch(error => {
            console.error(error);
        });
}

/**
 * Request tipo GET para obtener branch_office.
 * @author Jhon García
 */
export async function getBranchOffice({commit, state}) {

    let id = localStorage.selected_branchoffice;

    await $http
        .get(`/api/sedes/${id}`)
        .then(response => {
            commit('setBranchOffice', response.data.data);
        })
        .catch(error => {
            console.error(error);
        });
}

/**
 * Request tipo GET para obtener contact_warehouse.
 * @author Jhon García
 */
export async function getContactWarehouse({commit, state}) {

    if (!state.client.id) {
        return;
    }

    await $http
        .get(`/api/sucursal-tercero/${state.client.id}`)
        .then(response => {
            commit('setContactWarehouse', response.data.data);
        })
        .catch(error => {
            console.error(error);
        });
}

export async function getContactVehiclesById({commit, state}, contact_id) {
    await $http
        .get(`/api/contact-vehicles/${contact_id}`)
        .then(response => {
            commit('setContactVehicles', response.data.data);
        }).catch(error => {
            Notification.error({
                title: '¡Error!',
                message: error.message,
                type: 'error',
                duration: 1500,
                customClass: 'notification-box'
            });
        });

}


// WEBPACK FOOTER //
// ./src/modules/clients-component/actions.js